module.exports = __webpack_public_path__ + "727b03ae4f09a4907cd1b06f769c92ed.png";